import { render, staticRenderFns } from "./rms-objects-detail-tab.vue?vue&type=template&id=61e63252&scoped=true"
import script from "./rms-objects-detail-tab.vue?vue&type=script&lang=js"
export * from "./rms-objects-detail-tab.vue?vue&type=script&lang=js"
import style0 from "./rms-objects-detail-tab.vue?vue&type=style&index=0&id=61e63252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e63252",
  null
  
)

export default component.exports